<div class="com-loader {{ direction }}">
  <img *ngIf="color === 'white'" class="{{ size }}" src="assets/Eclipse-white.svg" />
  <img *ngIf="color === 'blue'" class="{{ size }}" src="assets/eclipse.svg" />
  <p *ngIf="withText" [ngClass]="{'txt-white': color==='white'}">{{ text | translate }}</p>
</div>
